// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bg-overlay[data-v-15949865]{background-image:linear-gradient(180deg,rgba(0,0,0,.4) 0,rgba(0,0,0,.4) 100%),var(--hero-background-image);background-position:50%;background-size:cover}.max-w-lg[data-v-15949865]{max-width:600px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
